<template>
  <div class="wrap">
    <div class="wrap-header">
      <span class="cdn-logo">XPSCDN|兴盛优选</span>
      <div class="upload">
        <el-button type="text" class="oprate" @click="showDialog('project')">新建项目</el-button>
        <el-button type="text" class="oprate" @click="showDialog('version')">新建版本</el-button>
        <el-button type="text" class="oprate" @click="showDialog('upload')">上传资源</el-button>
      </div>
      <div class="header-content">
        <h1 class="title">XPSCDN</h1>
        <p class="description">定制化、更安全、更稳定、更快速的前端项目CDN加速服务</p>
      </div>
      <div class="search">
        <el-input v-model="project" @keyup.enter.native="getProjects(project)" placeholder="搜索cdn 资源，比如jquery" class="cdn-input" /><i class="el-icon-search icon" @click="getProjects(project)"></i>
      </div>
    </div>
    <div class="wrap-body">
      <div class="project-body">
        <el-row class="project-row" v-for="(item, index) in tableData" :key="index" @click="handleCurrentChange(item)">
          <el-col :span="6">
            <div class="project-name" @click="handleCurrentChange(item)">{{item.projectName}}</div>
          </el-col>
          <el-col :span="18">
            <div class="project-descript" @click="handleCurrentChange(item)">{{item.projectDescript}}</div>
            <i class="el-icon-delete delete-icon" title="删除" @click.stop="deleteProject(item.id)"></i>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog v-if="show" :title="title" @close="handleClose" @open="handleOpen" :visible.sync="dialogVisible" width="800px">
      <el-alert v-if="type==='upload'" class="upload-alert" :title="alertTitle" type="warning">
      </el-alert>
      <el-form v-if="type==='upload'" :model="uploadForm" ref="form" label-width="100px" class="demo-dynamic">
        <el-form-item prop="projectId" label="项目名称:" :rules="[
                { required: true, message: '请选择项目名称', trigger: 'change' },
                ]">
          <el-select style="width: 100%" clearable filterable v-model="uploadForm.projectId" placeholder="请选择" @change="projectChange">
            <el-option v-for="item in tableData" :key="item.id" :label="item.projectName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="versionId" label="版本名称:" :rules="[
                { required: true, message: '请选择版本名称', trigger: 'change' },
                ]">
          <el-select style="width: 100%" clearable filterable v-model="uploadForm.versionId" placeholder="请选择">
            <el-option v-for="item in versions" :key="item.id" :label="item.versionName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传类型:" :rules="[{ required: true, message: '请选择上传文件类型', trigger: 'change'},]">
          <el-radio-group v-model="isUploadDirectory">
            <el-radio :label="false">普通文件</el-radio>
            <el-radio :label="true">文件夹</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="linkCdnAddress" :label="'上传资源:'" :rules="[
                { required: true, message: '请上传资源', trigger: 'blur'},
                ]">
          <el-upload ref="upload" :disabled="!uploadForm.versionId" class="upload-demo" action="" :multiple="true" :show-file-list="!showCdnBox" :http-request="uploadFile" :file-list="fileList" :on-remove="handleRemove">
            <div class="upload-button-left">
              <el-button :disabled="!uploadForm.versionId" type="warning" icon="el-icon-upload">点击上传</el-button>
            </div>
          </el-upload>

          <div class="cdn-box" v-if="showCdnBox">
            <div v-for="link in uploadForm.linkCdnAddress" :key="link">
              {{link}}
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="linkCdnAddress" :label="'资源描述:'">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" resize="none" :placeholder="linkPlaceHolder" style="width:100%;display:block;" v-model="uploadForm.linkDescript">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button type="danger" @click="showCdnBox=!showCdnBox">{{showCdnBox?'查看文件列表':'查看CDN链接'}}</el-button>
        </el-form-item>
      </el-form>
      <el-form v-if="type==='project'" :model="projectForm" ref="form" label-width="100px" class="demo-ruleForm">
        <el-form-item label="项目名称：" prop="projectName" :rules="[
                { required: true, message: '项目名称不能为空'}
                ]">
          <el-input v-model="projectForm.projectName" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="项目描述：" prop="projectDescript" :rules="[
                { required: true, message: '项目描述不能为空'}
                ]">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" resize="none" placeholder="请输入项目描述" v-model="projectForm.projectDescript">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitProject">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
      <el-form v-if="type==='version'" :model="versionForm" ref="form" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="projectId" label="项目名称:" :rules="[
                { required: true, message: '请选择项目名称', trigger: 'change' },
                ]">
          <el-select style="width:100%" clearable filterable v-model="versionForm.projectId" placeholder="请选择" @change="projectChange">
            <el-option v-for="item in tableData" :key="item.id" :label="item.projectName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本名称：" prop="versionName" :rules="[
                { required: true, message: '版本名称不能为空'}
                ]">
          <el-input v-model="versionForm.versionName" placeholder="请输入版本名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitVersion">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { cdnsApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
export default {
  data () {
    return {
      show: true,
      title: '',
      type: '',
      tableData: [],
      project: "",
      versions: [],
      fileList: [],
      dialogVisible: false,
      projectForm: {
        projectName: '',
        projectDescript: ''
      },
      versionForm: {
        projectId: '',
        versionName: ''
      },
      uploadForm: {
        projectId: '',
        versionId: '',
        linkCdnAddress: [],
        linkDescript: ''
      },
      showCdnBox: true,
      isUploadDirectory: false,
      linkPlaceHolder: '提示：批量上传CDN资源时，默认以第一个资源描述进行全部资源描述，如需对不同资源进行描述，请用“;”对描述信息进行分割，且必须以CDN资源显示顺序进行描述（不能以上传文件列表顺序进行描述！！！）',
      alertTitle: '上传同项目同版本同名称的CDN资源（会导致返回CDN地址相同），上传时都会默认覆盖原有的CDN资源，请谨慎上传！'
    }
  },
  watch: {
    isUploadDirectory (val) {
      if (val) {
        this.$refs['upload'].$children[0].$refs.input.webkitdirectory = true;
      } else {
        this.$refs['upload'].$children[0].$refs.input.webkitdirectory = false;
      }
    },
  },
  mounted () {
    this.getProjects();
  },
  methods: {
    handleClose () {
      this.uploadForm.linkCdnAddress = [];
      this.uploadForm.linkDescript = '';
      this.$refs.form.resetFields();
      this.getProjects();
      this.show = false;
    },
    handleOpen () {
      this.show = true;
    },
    handleRemove (file, fileList) {
      this.fileList = fileList;
      this.uploadForm.linkCdnAddress = this.uploadForm.linkCdnAddress.filter(item => item.indexOf(file.name) === -1)
    },
    // 资源上传
    async uploadFile (params) {
      const form = new FormData();
      // 文件对象
      form.append("file_data", params.file);
      form.append("fileName", params.file.name);
      form.append("fileExt", params.file.type);
      const projectName = this.tableData.filter(item => {
        return item.id == this.uploadForm.projectId
      })[0].projectName
      const versionName = this.versions.filter(item => {
        return item.id == this.uploadForm.versionId
      })[0].versionName
      form.append("uploadPath", `/libs/${projectName}/${versionName}/`);
      try {
        let data = await cdnsApi.openApi(form);
        this.uploadForm.linkCdnAddress.push(data.cdnPath);
        this.$message.success('文件上传成功！')
      } catch (e) {
        console.log('uploadRequest error', e);
        that.$message.error('上传图片出错或文件过大！');
        return null;
      }
    },
    // 新建项目
    submitProject () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await cdnsApi.createProject({
            ...this.projectForm
          })

          if (res.code === 200) {
            this.$message.success(`创建${this.projectForm.projectName}成功！`);
            this.dialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
        }
      })
    },
    // 新建版本
    async submitVersion () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await cdnsApi.createVersion({
            ...this.versionForm
          })
          if (res.code === 200) {
            this.$message.success(`创建${this.versionForm.versionName}成功！`)
            this.dialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
        }
      })
    },
    // 获取版本
    async projectChange (val) {
      const { data } = await cdnsApi.getVersionList({
        projectId: val
      })
      if (data) {
        this.versions = data;
        this.uploadForm.versionId = '';
      }
    },
    submitForm () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const { data } = await cdnsApi.saveLink({
            ...this.uploadForm
          })
          if (data) {
            this.$message.success("保存成功！")
            this.dialogVisible = false;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm () {
      this.$refs.form.resetFields();
    },
    async getProjects (val) {
      showLoading();
      const params = {}
      if (val) {
        params.projectName = val
      }
      const { data } = await cdnsApi.getProjectList(params);
      if (data) {
        this.tableData = data;
      }
      hideLoading();
    },
    handleCurrentChange (row) {
      let param = {
        id: row.id,
        projectName: row.projectName,
        projectDescript: row.projectDescript
      }
      this.$router.push({ path: '/xpsCdn/version', query: param });
    },
    showDialog (val) {
      this.show = true;
      this.type = val
      if (val === 'project') {
        this.title = "新建项目"
      } else if (val === "version") {
        this.title = "新建版本"
      } else {
        this.title = "上传资源"
      }
      this.dialogVisible = true;
    },
    // 删除项目
    deleteProject (id) {
      this.$confirm('您确定要删除该项目吗？删除项目之后项目将会不可见，项目资源依旧能使用！', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await cdnsApi.deleteProject({ id })
        if (res.code === 200) {
          this.getProjects();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
}
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .wrap-header {
    height: 260px;
    background-color: #ecf5ff;
    width: 100%;
    position: relative;
    .cdn-logo {
      display: block;
      color: #5862ab;
      line-height: 30px;
      font-size: 24px;
      position: absolute;
      top: 32px;
      left: 70px;
    }
    .header-content {
      width: 100%;
      .title {
        position: absolute;
        top: 25px;
        left: 50%;
        transform: translateX(-50%);
        color: #5862ab;
        font-size: 56px;
        text-shadow: -5px 5px 0px #ccc;
      }
      .description {
        position: absolute;
        top: 140px;
        left: 50%;
        transform: translateX(-50%);
        color: #5862ab;
      }
    }
    .search {
      width: 50%;
      text-align: center;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      .cdn-input {
        outline: none;
        font-size: 18px;
      }
      .icon {
        position: absolute;
        top: 9px;
        right: 10px;
        font-size: 24px;
        color: #ccc;
        cursor: pointer;
      }
    }
    .upload {
      // color: white;
      font-size: 18px;
      position: absolute;
      top: 32px;
      right: 70px;
      .oprate {
        font-size: 16px;
        color: #5862ab;
      }
    }
  }
  .wrap-body {
    flex: 1;
    width: 100%;
    background-color: #fff;
    overflow: auto;
    .project-body {
      width: 1150px;
      margin: 30px auto;
      border: 1px solid #ecf0f1;
      border-radius: 10px;
      overflow: hidden;
      .project-row:hover {
        cursor: pointer;
        background-color: #ecf5ff;
        .delete-icon {
          display: block;
        }
      }
      .project-row {
        position: relative;
        display: flex;
        align-items: center;
        line-height: 32px;
        padding: 10px 20px;
        border-bottom: 1px solid #ecf0f1;
        &:nth-last-child(1) {
          border: 0;
        }
        .project-name {
          margin: 0;
          font-size: 16px;
          color: #5862ab;
          font-weight: 700;
        }
        .delete-icon {
          position: absolute;
          display: none;
          top: 50%;
          right: 20px;
          padding: 10px;
          color: #5862ab;
          font-size: 16px;
          font-weight: 700;
          border-radius: 50%;
          background-color: #fff;
          opacity: 0.6;
          transform: translateY(-50%);
          transition: all 0.3s ease;
          &:hover {
            transform: scale(1.5) translateY(-50%);
            color: red;
          }
        }
        .project-descript {
          color: rgb(157, 157, 168);
          font-size: 14px;
        }
      }
    }
  }
}
.upload-alert {
  margin: -15px 0 15px 0;
}
.upload-demo {
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 10px;
  .upload-button-left {
    text-align: left;
  }
}
::v-deep .el-table tbody {
  cursor: pointer;
}
::v-deep .search {
  .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
  }
}
</style>